import { render } from "./WaardrobeEntrance.vue?vue&type=template&id=20fcbca7&scoped=true"
import script from "./WaardrobeEntrance.vue?vue&type=script&lang=js"
export * from "./WaardrobeEntrance.vue?vue&type=script&lang=js"

import "./WaardrobeEntrance.vue?vue&type=style&index=0&id=20fcbca7&scoped=true&lang=css"

import exportComponent from "/media/riven/projects/aavegotchi/waardrobe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fcbca7"]])

export default __exports__